import React from 'react';
import { useFieldStyles } from './hooks/useFieldStyles.js';
import { FieldWrap } from './FieldWrap.js';

const SelectIconWrapper = ({ children, className, icon, }) => (React.createElement("div", { className: ['relative', className].join(' ') },
    children,
    icon && (React.createElement("img", { className: "absolute top-1/2 left-4 my-reset transform -translate-y-1/2 w-3 h-full object-contain", src: icon, alt: "" }))));
const SelectFieldNative = React.forwardRef(({ className = '', icon, invalid, theme = 'dark', placeholder, options, ...rest }, ref) => {
    const styles = useFieldStyles({
        invalid,
        theme,
        ...rest,
    });
    return (React.createElement(SelectIconWrapper, { ...{ className, icon } },
        React.createElement("select", { ...{
                ...rest,
                'aria-invalid': invalid,
                className: [
                    styles,
                    'pr-8',
                    'bg-select',
                    'bg-input-size',
                    'overflow-ellipsis',
                    icon ? 'pl-10' : '',
                    className,
                ].join(' '),
                ref,
            } },
            placeholder && (React.createElement("option", { value: "", disabled: true, hidden: true }, placeholder)),
            options.map(({ label, value }, i) => (React.createElement("option", { key: i, value: value }, label))))));
});
const SelectFieldNativeControlled = ({ options, placeholder, theme, ...props }) => (React.createElement(FieldWrap, { ...{ theme, ...props } },
    React.createElement(SelectFieldNative, { ...{
            options,
            placeholder,
            theme,
            suppressHydrationWarning: true,
        } })));

export { SelectFieldNative, SelectFieldNativeControlled, SelectIconWrapper };
//# sourceMappingURL=SelectFieldNative.js.map
